import styled, { keyframes } from "styled-components";
import { ErrorMessage } from "formik";
import TextInput from "../../components/TextInput";
import TextArea from "../../components/TextArea";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdCloseCircle } from "react-icons/io";
import { TiWarning } from "react-icons/ti";
export const Loader = styled.div`
  border: 4px solid #f3f3f3;
  border-top: 4px solid #3498db;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  animation: spin 2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const Asterisk = styled.span`
  color: red;
  margin-left: 4px; /* Ajusta el espacio entre el texto del label y el asterisco */
`;

export const fadeAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
`;

export const DivContenedorMax = styled.div`
  display: flex;
  justify-content: center;
  background-color: #fff;
  width: 100%;
  height: auto
  border-radius: 5px;
  @media screen and (max-width: 780px) {  
      background-color: #fff;
  }  
 
`;

export const Div = styled.div`
  border-radius: 15px;
  margin-left: 5%;
  margin-right: 5%;
  margin-bottom: 5%;
  background-color: #fff;
  padding-left: 2%;
  padding-top: 85px; /* Ajuste para dejar espacio para el navbar */
  padding-bottom: 8%;
  position: relative; /* No se necesita cambiar esto */
  height: 100%;
  min-height: 900px;
  width: 1050px;
  max-width: 1050px;
  transition: opacity 0.3s ease;

  @media screen and (max-width: 780px) {
    height: auto;
    min-height: 100%;
    width: 100vw; /* ancho del viewport */
    margin-left: 0; /* Elimina margen izquierdo */
    padding-left: 10px; /* Ajusta según sea necesario */
    margin-right: 0; /* Elimina margen derecho */
    padding-right: 10px; /* Ajusta según sea necesario */
    max-width: 100%; /* Asegura que el contenedor se expanda completamente */
    height: 100vh; /* Permite que la altura mínima se ajuste al contenido */
    position: relative; /* Asegura que el contenedor se adapte a la altura del contenido */
    padding-bottom: 5%;
    padding-top: 95px; /* Ajusta para dispositivos móviles también */
  }
`;

export const DivNavbar = styled.div`
  position: fixed; /* Cambiar a posición fija */
  top: 0; /* Colocarla en la parte superior */
  left: 0; /* Asegurar que ocupe todo el ancho */
  width: 100%;
  background-color: #f1f1f1; /* Puedes establecer el fondo si es necesario */
  /* Es posible que también desees añadir un poco de padding o altura según tu diseño */
  padding: 0px; /* Ajusta esto según sea necesario */
  z-index: 999;
  margin-bottom: 50%;
`;

export const DivFlex = styled.div`
  margin-top: -25px;
  display: flex;
  gap: 10%;
  justify-content: center;
  align-items: flex-start;
  align-text: center;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }

  &.fade {
    animation: ${fadeAnimation} 0.5s;
  }

  &.fade-out {
    animation: ${fadeAnimation} 0.5s reverse;
  }
`;

export const DivForm = styled.div``;

export const Label = styled.label`
  font-weight: bold;
  margin-right: 5px;
  margin-top: 0px;
  margin-buttom: 0px;
`;
export const ErrorMessageStyled = styled(ErrorMessage)`
  display: inline-block;
  color: red; /* Puedes ajustar el estilo del mensaje de error aquí */
  margin-left: 3px; /* Espacio entre el label y el mensaje de error */
`;

export const ButtonSubir = styled.button`
  padding: 7px 17px;
  background-color: #11cdde;
  color: black;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 1%;
  margin-right: 0%;
  bottom: 2%;
  &:hover {
    color: white;
    background-color: #07b4c4;
  }
`;

export const ButtonNext = styled.button`
  padding: 10px 20px;
  background-color: #42adea;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 1%;
  bottom: 2%;
  &:hover {
    background-color: #3592c8;
  }
`;
export const ButtonAtras = styled.button`
  padding: 10px 20px;
  background-color: #42adea;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 1%;
  bottom: 2%;

  &:hover {
    background-color: #3592c8;
  }
`;
export const ButtonEnviar = styled.button`
  padding: 10px 20px;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin: 1%;
  bottom: 2%;
  background-color: #3cb371;
  &:hover {
    background-color: #359b62;
  }
  &:disabled {
    background-color: #e7e7e7; /* Fondo cuando está deshabilitado */
    color: #a0a0a0; /* Color del texto cuando está deshabilitado */
    cursor: not-allowed; /* Cambiar cursor cuando está deshabilitado */
    pointer-events: none; /* Deshabilitar efectos hover */
  }
`;
export const DivError = styled.button`
  border: none;
  padding: 5px;
  color: black;
  height: auto;
  margin: 1%;
  bottom: 0%;
  background-color: salmon;
  border-radius: 5px;
  border: solid 1px;
  border-color: black;
`;
export const DivSinErrores = styled.div`
  border: none;
  padding: 5px;
  color: black;
  height: auto;
  margin: 1%;
  bottom: 0%;
  background-color: #3cb371;

  border-radius: 5px;
  border: solid 1px;
  border-color: black;
`;

export const DivButtons = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  margin-top: 2%;
  margin: 0px;
  bottom: 3%;
  @media screen and (max-width: 780px) {
    position: relative;
    bottom: 15%;
    margin-bottom: 10%;
    width: 100%;
  }
`;

export const DivContenedorError = styled.div`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  bottom: 0;
  width: 95%;
`;

export const ProgressBar = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @media screen and (max-width: 780px) {
    margin-top: 2%;
    justify-content: center;
    align-items: center;
    width: auto;
  }
`;

export const StepProgress = styled.div`
  flex: 1;
  display: flex; /* Añade esta línea para hacer que los pasos se alineen horizontalmente */
  @media screen and (max-width: 780px) {
    margin-bottom: 5%;
  }
`;

export const Step = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  flex: 1; /* Opcional: Esto asegura que cada Step ocupe el mismo espacio horizontalmente */
  animation: ${fadeAnimation} 0.5s ease-in-out;
  @media screen and (max-width: 780px) {
    flex-direction: row; /* Ajusta la dirección del flexbox a horizontal */
    justify-content: center; /* Centra los elementos en el eje principal */
    align-items: center; /* Centra los elementos en el eje secundario */
  }
`;

export const Bullet = styled.div`
  position: relative;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: ${(props) =>
    props.active === "true" ? "#76c7c0" : "#e0e0df"};
  display: flex;
  justify-content: center;
  align-items: center;
  color: ${(props) => (props.active === "true" ? "white" : "black")};
  font-weight: bold;
  z-index: 10;
  cursor: pointer; /* Agrega esta línea para mostrar la mano de selección */
  &:hover {
    background-color: #61a29c;
  }
  @media screen and (max-width: 780px) {
    margin-top: 10%;
  }
`;

export const StepTitle = styled.p`
  margin-top: 10px;
  @media screen and (max-width: 780px) {
    display: none;
    margin: 0;
    padding: 0;
    height: 0;
    overflow: hidden;
    visibility: hidden;
  }
`;

export const shakeAnimation = keyframes`
  0% {
    transform: translateX(0);
  }
  10% {
    transform: translateX(-5px);
  }
  20% {
    transform: translateX(5px);
  }
  30% {
    transform: translateX(-5px);
  }
  40% {
    transform: translateX(5px);
  }
  50% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(0);
  }
`;

export const SaveIcon = styled.button`
  padding: 7px;
  border-radius: 5px;
  border: none;
  position: absolute;
  left: 2%;
  top: 145px;
  display: block;
  background-color: #5bc0de;
  transition: width 0.3s ease, height 0.3s ease;

  &:hover {
    background-color: #50aac5;
    color: white;
  }
  @media screen and (max-width: 780px) {
    top: 16%;
  }
`;

export const CheckIcon = styled(FaCheckCircle)`
  position: absolute;
  margin-left: -3%;
  margin-bottom: 20px;
  display: block;
  color: #22bb33;
  z-index: 10;
`;

export const CloseIcon = styled(IoMdCloseCircle)`
  position: absolute;
  margin-left: -3%;
  margin-bottom: 20px;
  display: block;
  color: #bb2124;
  z-index: 10;
`;

export const WarningIcon2 = styled(TiWarning)`
  height: 23px;
  width: auto;
  display: inline-block;
  color: #ffcc00;
  z-index: 99999;
  margin-left: 1px;
  vertical-align: middle;
`;

export const H2 = styled.h2`
  margin-top: -5px;
  display: block;
  font-size: 1.5em;
  margin-block-start: 0.83em;
  margin-block-end: 0.83em;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
  font-weight: bold;
`;

export const DivFlex2 = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }

  &.fade {
    animation: ${fadeAnimation} 0.5s;
  }

  &.fade-out {
    animation: ${fadeAnimation} 0.5s reverse;
  }
`;

export const FormSection = styled.div`
  flex: 1;
  min-width: 300px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 5px;
`;

export const FormLabel = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const TextComment = styled(TextArea)`
  width: 100%;
  height: 80px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
`;
export const TextArea2 = styled.textarea`
  width: 100%;
  height: 80px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
`;

export const RadioGroup = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
`;
export const LabelRadio = styled.label`
  display: flex;
  align-items: center;
  font-size: 0.85rem;
`;

export const RadioInput2 = styled.input`
  margin-right: 10px;
`;

export const WarningIcon = styled.span`
  margin-left: 5px;
  color: #f39c12;
`;

export const DivFlex3 = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }

  &.fade {
    animation: ${fadeAnimation} 0.5s;
  }

  &.fade-out {
    animation: ${fadeAnimation} 0.5s reverse;
  }
`;

export const FieldP3 = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const FormSection3 = styled.div`
  flex: 1;
  min-width: 300px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 5px;
`;

export const FormLabel3 = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const TextArea3 = styled.textarea`
  width: 100%;
  height: 80px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  margin-bottom: 10px;
`;

export const RadioGroup3 = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
`;

export const RadioInputWrapper = styled.div`
  flex: 1;
  min-width: 100px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;

export const RadioInput3 = styled.input`
  margin-right: 5px;
`;

export const WarningIcon3 = styled.span`
  margin-left: 5px;
  color: #f39c12;
`;

export const Table3 = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  th {
    background-color: #f2f2f2;
    text-align: left;
  }

  td {
    background-color: #fff;
  }
`;

export const DivFlex4 = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
  align-items: flex-start;

  @media screen and (max-width: 780px) {
    flex-direction: column;
  }

  &.fade {
    animation: ${fadeAnimation} 0.5s;
  }

  &.fade-out {
    animation: ${fadeAnimation} 0.5s reverse;
  }
`;

export const FormSection4 = styled.div`
  flex: 1;
  min-width: 300px;
  background: #f9f9f9;
  border: 1px solid #ddd;
  padding: 20px;
  border-radius: 5px;
`;

export const FormLabel4 = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
`;

export const TextArea4 = styled.textarea`
  width: 100%;
  height: 80px;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: vertical;
  margin-bottom: 10px;
`;

export const RadioGroup4 = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 15px;
`;

export const RadioInputWrapper4 = styled.div`
  flex: 1;
  min-width: 100px;
  display: flex;
  align-items: center;
  margin-bottom: 5px;
`;

export const RadioInput4 = styled.input`
  margin-right: 5px;
`;

export const WarningIcon4 = styled.span`
  margin-left: 5px;
  color: #f39c12;
`;

export const FieldP5 = styled(TextInput)`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
`;

export const FieldPresupuesto = styled.textarea`
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 4px;
  resize: none;
  height: 100px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 15px;

  th,
  td {
    border: 1px solid #ddd;
    padding: 8px;
  }

  th {
    background-color: #f2f2f2;
    text-align: left;
  }

  td {
    background-color: #fff;
  }
`;
